import type {AdLocation} from '@frontend/modules/public/ads/AdsModuleTypes'

// Поиск локации по имени (рекурсивный).
export function findLocationByName(
    locations: AdLocation[],
    name: string | null
): null | AdLocation {
    if (!name) {
        return null
    }
    name = name.trim()
    for (const item of locations) {
        if (item.name === name) {
            return item
        } else if (item.children.length) {
            const location: AdLocation | null = findLocationByName(
                item.children,
                name
            )
            if (location) {
                return location
            }
        }
    }
    return null
}
